// services/sys-role-activity.service.ts
import axios from "../../department-viags/config.service";

export interface SysRoleActivityRequest {
  id: string; // Guid
}

export type UpdateSysRoleActivityRequest = {
  roleId: string;
  activities: SysRoleActivityRequest[];
};

export interface SysActivityResponse {
  id: string; // Guid => string
  code: string;
  name: string;
  description?: string;
}

export interface ActivityResponse extends SysActivityResponse {
  hasActivity: boolean;
}

export interface RoleActivityResponse {
  roleId: string; // Guid => string
  roleName?: string;
  activities: ActivityResponse[];
}

export interface SysRoleActivityResponseList {
  activities: SysActivityResponse[];
  roleActivities: RoleActivityResponse[];
}

type ApiResponse<T> = { data: T; statusCode: number };

const BASE = "/qltl/sysroleactivity";

export class SysRoleActivityService {
  /**
   * GET /GetRoleActivities?roleId={roleId}
   */
  static async getRoleActivities(roleId: string) {
    try {
      const res = await axios.get<ApiResponse<SysRoleActivityRequest[]>>(`${BASE}/GetRoleActivities`, {
        params: { roleId },
      });
      if (res.data.statusCode !== 200) return;
      return res.data.data;
    } catch (error: any) {
      console.log(error);
    }
  }

  /**
   * GET /GetRoleActivities?roleId={roleId}
   */
  static async getListRoleActivities() {
    try {
      const res = await axios.get<ApiResponse<SysRoleActivityResponseList[]>>(`${BASE}/GetListRoleActivity`);
      if (res.data.statusCode !== 200) return;
      return res.data.data;
    } catch (error: any) {
      console.log(error);
    }
  }

  /**
   * POST /CreateRoleActivities?roleId={roleId}
   * body: SysRoleActivityRequest[]
   */
  static async createRoleActivities(roleId: string, req: SysRoleActivityRequest[]) {
    try {
      const res = await axios.post<ApiResponse<boolean>>(`${BASE}/CreateRoleActivities`, req, { params: { roleId } });
      if (res.data.statusCode !== 200) return;
      return res.data.data;
    } catch (error: any) {
      console.log(error);
    }
  }

  /**
   * PUT /UpdateRoleActivities
   * body: SysRoleActivityRequest[]
   */
  static async updateRoleActivities(req: UpdateSysRoleActivityRequest) {
    try {
      const res = await axios.put<ApiResponse<boolean>>(`${BASE}/UpdateRoleActivities`, req);
      if (res.data.statusCode !== 200) return;
      return res.data.data;
    } catch (error: any) {
      console.log(error);
    }
  }

  /**
   * DELETE /DeleteRoleActivities
   * body: Guid[]
   * Lưu ý: axios.delete gửi body qua config.data
   */
  static async deleteRoleActivities(ids: string[]) {
    try {
      const res = await axios.delete<ApiResponse<boolean>>(`${BASE}/DeleteRoleActivities`, { data: ids });
      if (res.data.statusCode !== 200) return;
      return res.data.data;
    } catch (error: any) {
      console.log(error);
    }
  }
}
